import * as React from "react"
export const SvgComponent = ({ title, handleCircle, ...props }) => {



    return (
        <div className="svgContainer">
            <h2>{title}</h2>
            <svg
                width={700} height={700}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 587.82 839.59"
                {...props}
            >
                <defs>
                    <style>
                        {
                            ".cls-1, .cls-2 {fill: none;}.cls-3 {fill: #5b5b5f;  font-family: MyriadPro-Regular, 'Myriad Pro';  font-size: 21px;}.cls-3, .cls-4 {isolation: isolate;}.cls-5 {fill: #fff;}.cls-5, .cls-2 {stroke: #000;  stroke-miterlimit: 10;}"
                        }
                    </style>
                </defs>
                <g id="Capa_1-2" data-name="Capa 1">
                    <ellipse
                        className="cls-5"
                        cx={295.55}
                        cy={785.76}
                        rx={199.33}
                        ry={53.33}
                    />
                    <rect
                        className="cls-5"
                        x={145.8}
                        y={48.52}
                        width={296.43}
                        height={732.32}
                    />
                    <path
                        className="cls-5"
                        d="m145.8,780.83c0,12.61,66.36,22.83,148.21,22.83s148.22-10.22,148.22-22.83-66.36-22.83-148.21-22.83-148.22,10.22-148.22,22.83"
                    />
                    <ellipse
                        className="cls-5"
                        cx={294.02}
                        cy={48.14}
                        rx={148.21}
                        ry={16.38}
                    />
                </g>
                <g id="Capa_2" data-name="Capa 2">
                    <path d="m442.5,208.95c2.27-8.55,6.53-16.52,12.22-23.29,5.69-6.76,12.76-12.34,20.7-16.22,4.46-2.18,9.18-3.79,14.05-4.79.63-.13.36-1.09-.27-.96-8.8,1.8-17.12,5.65-24.31,11.01-7.18,5.36-13.26,12.19-17.66,19.99-2.48,4.4-4.41,9.1-5.71,13.98-.15.64.82.9.98.28h0Z" />
                    <line className="cls-2" x1={489.34} y1={164.18} x2={569.84} y2={164.18} />
                    <rect
                        className="cls-2"
                        x={480.88}
                        y={78.43}
                        width={106.44}
                        height={86.22}
                    />
                    <line className="cls-2" x1={480.6} y1={78.43} x2={450.23} y2={0.66} />
                    <line className="cls-2" x1={586.58} y1={78.43} x2={541.61} y2={0.5} />
                    <line className="cls-2" x1={450.23} y1={0.66} x2={541.61} y2={0.5} />
                    <line className="cls-2" x1={480.45} y1={160.05} x2={452.89} y2={64.15} />
                    <line className="cls-2" x1={450.23} y1={0.66} x2={452.89} y2={64.15} />
                    <line className="cls-2" x1={489.34} y1={164.18} x2={442.23} y2={165.32} />
                    <line className="cls-2" x1={442.26} y1={155.97} x2={480.88} y2={156.59} />
                    <path d="m146.28,216.12c-2.3-8.67-6.62-16.72-12.36-23.59-5.75-6.88-12.96-12.57-21.02-16.51-4.54-2.22-9.34-3.88-14.29-4.89-.63-.13-.9.84-.27.96,8.66,1.77,16.83,5.54,23.92,10.8,7.1,5.27,13.1,12.04,17.44,19.74,2.44,4.33,4.33,8.94,5.6,13.74.18.64,1.15.38.98-.25h0Z" />
                    <line className="cls-2" x1={98.48} y1={171.62} x2={17.98} y2={171.62} />
                    <rect className="cls-2" x={0.5} y={85.87} width={106.44} height={86.22} />
                    <line className="cls-2" x1={107.22} y1={85.87} x2={137.59} y2={8.1} />
                    <line className="cls-2" x1={1.24} y1={85.87} x2={46.21} y2={7.94} />
                    <line className="cls-2" x1={137.59} y1={8.1} x2={46.21} y2={7.94} />
                    <line className="cls-2" x1={107.38} y1={167.49} x2={134.93} y2={71.58} />
                    <line className="cls-2" x1={137.59} y1={8.1} x2={134.93} y2={71.58} />
                    <line className="cls-2" x1={98.48} y1={171.62} x2={145.59} y2={172.76} />
                    <line className="cls-2" x1={145.56} y1={163.41} x2={106.94} y2={164.03} />
                </g>
                <g id="Capa_3" data-name="Capa 3">
                    <line className="cls-2" x1={205.98} y1={184.15} x2={207.8} y2={747.35} />
                    <path d="m205.95,183.22c-6.14.9-12.61.95-18.66-.58-4.7-1.19-9.36-3.32-12.75-6.87-1.87-1.96-3.22-4.32-3.9-6.94-.16-.62-1.13-.36-.96.27,2.69,10.36,14.39,14.89,24.07,15.59,4.16.3,8.34.12,12.47-.49.63-.11.36-1.07-.27-.98h0Z" />
                    <line className="cls-2" x1={170.16} y1={168.96} x2={170.16} y2={737.99} />
                    <path d="m205.96,746.75c-5.94,1.24-12.08,1.13-18.06.22-4.72-.72-9.8-1.67-13.83-4.39-1.99-1.35-3.59-3.2-4.27-5.54-.18-.62-1.14-.35-.96.27,1.29,4.48,5.46,7.05,9.62,8.52,2.51.89,5.14,1.43,7.76,1.88,3.12.54,6.27.89,9.43.95,3.55.08,7.1-.21,10.58-.94.62-.13.36-1.1-.27-.97h0Z" />
                </g>
                <g id="Capa_4" data-name="Capa 4">
                    <line className="cls-2" x1={381.58} y1={183.69} x2={379.75} y2={746.89} />
                    <path d="m381.34,183.73c6.35.94,13.02,1,19.27-.6,4.9-1.25,9.79-3.53,13.27-7.29,1.9-2.05,3.29-4.5,3.99-7.21.16-.62-.8-.89-.96-.27-2.58,9.95-13.96,14.22-23.22,14.86-4.03.28-8.09.12-12.08-.47-.63-.08-.9.89-.27.98h0Z" />
                    <line className="cls-2" x1={417.4} y1={168.5} x2={417.4} y2={737.53} />
                    <path d="m381.33,747.26c6.21,1.3,12.59,1.15,18.83.18,4.9-.76,10.24-1.79,14.32-4.8,1.99-1.47,3.55-3.4,4.24-5.8.18-.62-.79-.88-.96-.27-1.24,4.31-5.44,6.66-9.43,8-2.43.81-4.96,1.32-7.49,1.75-2.99.51-6.02.82-9.05.88-3.42.07-6.84-.21-10.19-.91-.63-.13-.9.84-.27.97h0Z" />
                </g>
                <g id="Capa_5" data-name="Capa 5">
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.27} cy={216.02} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.27} cy={243.5} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.27} cy={270.98} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={298.46} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={325.94} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={353.42} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={380.9} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={408.38} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.27} cy={435.86} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={463.34} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={490.82} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={518.3} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={545.78} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={573.26} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={600.74} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={628.22} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={187.91} cy={655.71} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={188.32} cy={683.19} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={187.91} cy={710.67} r={8.76} />
                </g>
                <g id="Capa_6" data-name="Capa 6">
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.59} cy={216.02} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.59} cy={243.5} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.59} cy={270.98} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={298.46} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={325.94} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={353.42} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={380.9} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={408.38} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.59} cy={435.86} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={463.34} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={490.82} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={518.3} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={545.78} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={573.26} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={600.74} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={628.22} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.23} cy={655.71} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.64} cy={683.19} r={8.76} />
                    <circle onClick={e => handleCircle(e)} className="cls-2" cx={399.23} cy={710.67} r={8.76} />
                </g>
                <g id="Capa_7" data-name="Capa 7">
                    <rect
                        className="cls-1"
                        x={103.56}
                        y={203.76}
                        width={206.67}
                        height={574.12}
                    />
                    <g
                        id="_1_2_3_4_5_6_7_8_9_10_11_12_13_14_15_16_17_18_19_20_"
                        data-name="12345 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20"
                        className="cls-4"
                    >
                        <text className="cls-3" transform="translate(103.56 218.67)">
                            <tspan x={0} y={0}>
                                {"46"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 246.67)">
                            <tspan x={0} y={0}>
                                {"48"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 274.67)">
                            <tspan x={0} y={0}>
                                {"50"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 302.67)">
                            <tspan x={0} y={0}>
                                {"52"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 330.67)">
                            <tspan x={0} y={0}>
                                {"54"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 358.67)">
                            <tspan x={0} y={0}>
                                {"56"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 386.67)">
                            <tspan x={0} y={0}>
                                {"58"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 414.67)">
                            <tspan x={0} y={0}>
                                {"60"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 442.67)">
                            <tspan x={0} y={0}>
                                {"62"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 470.67)">
                            <tspan x={0} y={0}>
                                {"64"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 498.67)">
                            <tspan x={0} y={0}>
                                {"66"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 526.67)">
                            <tspan x={0} y={0}>
                                {"68"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 554.67)">
                            <tspan x={0} y={0}>
                                {"70"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 582.67)">
                            <tspan x={0} y={0}>
                                {"72"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 610.67)">
                            <tspan x={0} y={0}>
                                {"74"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 638.67)">
                            <tspan x={0} y={0}>
                                {"76"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 666.67)">
                            <tspan x={0} y={0}>
                                {"78"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 694.67)">
                            <tspan x={0} y={0}>
                                {"80"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(103.56 722.67)">
                            <tspan x={0} y={0}>
                                {"82"}
                            </tspan>
                        </text>
                    </g>
                    <rect
                        className="cls-1"
                        x={456.76}
                        y={203.76}
                        width={92}
                        height={574.12}
                    />
                    <g
                        id="_1_2_3_4_5_6_7_8_9_10_11_12_13_14_15_16_17_18_19_20_-2"
                        data-name="12345 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20"
                        className="cls-4"
                    >
                        <text className="cls-3" transform="translate(456.76 218.67)">
                            <tspan x={0} y={0}>
                                {"46"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 246.67)">
                            <tspan x={0} y={0}>
                                {"48"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 274.67)">
                            <tspan x={0} y={0}>
                                {"50"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 302.67)">
                            <tspan x={0} y={0}>
                                {"52"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 330.67)">
                            <tspan x={0} y={0}>
                                {"54"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 358.67)">
                            <tspan x={0} y={0}>
                                {"56"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 386.67)">
                            <tspan x={0} y={0}>
                                {"58"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 414.67)">
                            <tspan x={0} y={0}>
                                {"60"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 442.67)">
                            <tspan x={0} y={0}>
                                {"62"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 470.67)">
                            <tspan x={0} y={0}>
                                {"64"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 498.67)">
                            <tspan x={0} y={0}>
                                {"66"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 526.67)">
                            <tspan x={0} y={0}>
                                {"68"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 554.67)">
                            <tspan x={0} y={0}>
                                {"70"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 582.67)">
                            <tspan x={0} y={0}>
                                {"72"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 610.67)">
                            <tspan x={0} y={0}>
                                {"74"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 638.67)">
                            <tspan x={0} y={0}>
                                {"76"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 666.67)">
                            <tspan x={0} y={0}>
                                {"78"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 694.67)">
                            <tspan x={0} y={0}>
                                {"80"}
                            </tspan>
                        </text>
                        <text className="cls-3" transform="translate(456.76 722.67)">
                            <tspan x={0} y={0}>
                                {"82"}
                            </tspan>
                        </text>
                    </g>
                </g>
            </svg>

        </div>
    )
}
